<template>
    <BaseLink
        :class="$style.profile"
        :to="{ name: ROUTE_NAMES.PROFILE }"
        data-interface-target="profile-link"
    >
        <UserAvatar
            :class="$style.avatar_override"
            :avatar="props.user.avatar"
            :firstName="props.user.firstName"
            :lastName="props.user.lastName"
        />
    </BaseLink>
</template>
<script setup lang="ts">
import BaseLink from '@/components/BaseLink.vue'
import UserAvatar from '@/components/UserAvatar.vue'
import { ROUTE_NAMES } from '@/router/constants'
import type { User } from '@/types'

const props = defineProps<{
    user: User
}>()
</script>
<style module>
.profile {
    border-radius: 1000px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--carbon-400);
    padding: 0;
}

.avatar_override {
    flex-shrink: 0;
    width: 48px;
    height: 48px;
}

@media (--desktop-small-plus) {
    .profile {
        transition: box-shadow 0.3s;
        padding: 4px;
        gap: clamp(2px, 1vw, 8px);
    }

    .profile:hover,
    .profile:focus {
        box-shadow: 0 0 30px 0 rgba(163, 109, 253, 0.64) inset;
        outline: 0.5px solid var(--purple-300);
    }

    .avatar_override {
        width: 48px;
        height: 48px;
    }
}
</style>
